// extracted by mini-css-extract-plugin
module.exports = {"Container":"DashboardRecentCards_Container__1iTSP","button":"DashboardRecentCards_button__2ILsi","Card":"DashboardRecentCards_Card__3KY2p"};